import React from 'react';
import Store from '../../../redux/store';
import { get, getConfig } from '../../../helpers';
import { getDefaultformFields, submitToMarketo } from '../utilities/form-utilities';

const RequestTrialForm = React.lazy(() => import('../index' /* webpackChunkName: "request-a-trial-form" */));

function getMarketoAPIVariant(variant: string): string {
    return getConfig(`components.request-a-trial.marketoAPIVariant.${variant}`, 'SolutionRAT') as string;
}

function getLeadVariant(temp: string): string {
    const tempArray = temp.split(',');
    const plattsAreas = ['Energy and Utilities', 'Materials', 'Industrials'];
    const marketoAreas = ['Financials', 'Real Estate', 'Healthcare', 'Consumer', 'Technology', 'Media and Telecommunications'];
    const checkPlatts = tempArray.filter(item => plattsAreas.includes(item));
    const checkMarketo = tempArray.filter(item => marketoAreas.includes(item));
    let tempVariant = 'Marketo';

    if (checkPlatts.length > 0 && checkMarketo.length === 0) {
        tempVariant = 'Platts';
    }
    return tempVariant;
}

function getSubmissionBody(
    data: RequestATrialState
) {
    const switchAPIRequest: RATRequest = {
        firstName: data.FirstName,
        lastName: data.LastName,
        company: data.Company,
        companyType1c: data.CompanyType as string,
        email: data.Email,
        phone: data.Phone,
        city: data.City,
        complianceCountry: data.Country as string,
        jobFunction1c: data.JobFunction as string,
        cInterestOther: data.OtherInterest,
        cInterestOtherLive: data.OtherInterest,
        state: data.State ? String(data.State) : '',
        spProductServiceInterestDetailsc: data.OtherInterest,
        spProductServiceInterestsc: data.InterestArea,
        gDPRConsentQuestion: String(data.HasUserConsent)
    } as RATRequest;

    if (data.MasterTrialAgreement) {
        switchAPIRequest.masterTrialAgreementActionMostRecent = data.MasterTrialAgreement;
        switchAPIRequest.masterTrialAgreementActionTimeStampMostRecent = new Date().toJSON();
    }
    return switchAPIRequest;
}

const getPlattsSubmissionBody = (
    productName: string,
    data: RequestATrialState,
) => {
    const body: RATPlattsRequest = {
        city: data.City,
        company: data.Company,
        marketoIndustry: data.CompanyType as string,
        country: data.CompanyCountry as string,
        nationality: data.Country as string,
        email: data.Email,
        firstName: data.FirstName,
        title: data.JobFunction as string,
        lastName: data.LastName,
        phone: data.Phone,
        productInterestc: productName,
        mktoPersonNotes: data.OtherInterest,
        state: String(data.CompanyState || ''),
        postalCode: data.PostalCode,
        optIn: data.HasUserConsent ? 'yes' : '',
        variant: 'Platts',
    };
    return body;
};

function RequestTrialSwitch(props: RequestATrialFormProps) {
    const { productName = '', marketMSADataLink, dataFilePath, productVariant, variant, titleText, keyPageIdPageText, ratVariant, marketplaceMSATooltip } = props;
    const switchFormFields = {
        ...getDefaultformFields(),
        InterestArea: {
            name: 'InterestArea', text: '', validationType: 'defaultRequired'
        }
    };

    const onSubmit = (
        data: RequestATrialState,
        cb: () => void,
        error: (error: string) => void
    ) => {
        const utmParameters: UTMParameters = get(Store.getState(), 'shared.utmParameters', {});
        let notapplicableText = data.InterestArea ? '' : 'Data Management Solutions';
        if (productVariant === 'solution') notapplicableText = productName;
        // data.OtherInterest = `${notapplicableText}`;
        let requestBody;
        if (data.InterestArea && getLeadVariant(data.InterestArea) === 'Platts') {
            requestBody = getPlattsSubmissionBody(productName, data);
            submitToMarketo(requestBody, cb, error);
        } else {
            data.OtherInterest = productName ? `${productName} : ${data.OtherInterest}` : data.OtherInterest;
            requestBody = getSubmissionBody(data);
            requestBody = {
                ...requestBody,
                utmSource: utmParameters.utmSource,
                utmMedium: utmParameters.utmMedium,
                utmCampaign: utmParameters.utmCampaign,
                utmTerm: utmParameters.utmTerm,
                utmContent: utmParameters.utmContent,
                variant: getMarketoAPIVariant(variant || '')
            };
            submitToMarketo(requestBody, cb, error);
        }
    };

    return (
        <RequestTrialForm onSubmitForm={onSubmit} formTextFields={switchFormFields} productVariant={productVariant} keyPageIdPageText={keyPageIdPageText} titleText={titleText} marketMSADataLink={marketMSADataLink} marketplaceMSATooltip={marketplaceMSATooltip} dataFilePath={dataFilePath} productName={productName} headerVariant={variant} ratVariant={ratVariant} />
    );
}

export default React.memo(RequestTrialSwitch);
